module.exports = __webpack_public_path__ + "static/media/DSC_6845-HDR.d46be7c8.jpg";